import {DocumentId} from "common/types/document";
import {Matter} from "common/types/matter";
import {MaybeUninitialised} from "modules/redux_types";

// Undefined until the family has loaded
export default function getFamilyDocumentIds(
  matter: MaybeUninitialised<Pick<Matter, "documents">> | null | undefined,
): DocumentId[] | undefined {
  if (
    !matter ||
    typeof matter !== "object" ||
    !Array.isArray(matter.documents)
  ) {
    return undefined;
  }
  return matter.documents.flatMap(document =>
    document.document_id ? [document.document_id] : [],
  );
}
